import {ChangeDetectorRef, Component, NgZone, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DocumentUtil} from '../../../global/util/DocumentUtil';
import {DomSanitizer, SafeStyle, SafeUrl} from '@angular/platform-browser';
import {DocumentService} from '../../../user/service/document.service';
import {Constant} from '../../../global/util/Constant';
import {Document} from '../../../user/model/Document';
import {InformType} from '../../../global/util/enum/InformType';
import {PersonService} from '../../../user/service/person.service';
import {Person} from '../../../user/model/Person';
import HttpStatusCode from '../../../global/util/HttpStatusCode';
import {SignService} from '../../../user/service/sign.service';
import {Dialog} from '../../../global/util/Dialog';
import {ConfirmComponent} from '../../../shared/confirm/confirm.component';
import {Response} from '../../../global/util/enum/Response';
import {StringUtil} from '../../../global/util/StringUtil';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TypeSignature} from '../../../global/util/TypeSignature';
import {UanatacaService} from '../../../user/service/uanataca.service';
import {Resource} from '../../../user/model/Resource';
import {LocalStorage} from '../../../global/util/LocalStorage';
import {Stamprubrictemporal} from '../../../user/model/Stamprubrictemporal';
import {StamprubrictemporalList} from '../../../user/model/StamprubrictemporalList';
import {Stampdatetime} from '../../../user/model/Stampdatetime';
import {StateSolcert} from '../../../global/util/validator/StateSolcert';
import {TranslateService} from '@ngx-translate/core';
import {ApplicationService} from '../../../user/service/application.service';
import {IdentificationDocument} from '../../../global/util/IdentificationDocument';
import {SignaturePadComponent} from '../../../shared/signature-pad/signature-pad.component';
import {
  AcceptTermsConditionsComponent
} from '../../../shared/accept-terms-conditions/accept-terms-conditions.component';
import {PublicService} from '../../../user/service/public.service';
import {TermPdfViewerComponent} from '../../../shared/term-pdf-viewer/term-pdf-viewer.component';
import {PersonDocumentType} from '../../../global/util/PersonDocumentType';
import {Subject} from 'rxjs';
import {CloneTool} from '../../../global/util/CloneTool';
import {GeolocationIofesign} from '../../../user/model/GeolocationIofesign';
import {GeolocationService} from '../../../user/service/geolocation.service';
import {IdentityValidationComponent} from '../../../shared/identity-validation/identity-validation.component';

@Component({
  selector: 'app-sign',
  templateUrl: './sign.component.html',
  styleUrls: ['./sign.component.css']
})
export class SignComponent implements OnInit {
  public signatureForm: FormGroup;
  public loading: boolean;
  public uanatacasignboxdatas: any;
  private hashIdentifier;
  public personId: number;
  public document: Document;
  public signBoxDataSelected: any;
  public person: Person;
  public wrongRequestPerson = true;
  // Muestra el estado de la solicitud de  validación de documentos.
  public wrongRequestPersonSolcert = true;
  // Muestra el boton que genera solicitud de validez de documento.
  public wrongRequestPersonSolcert1 = false;
  public wrongRequestDocument = true;
  // Confirmacion de identidad de una persona.
  public invalidPersonConfirmation: boolean;
  private title = 'TITLE.SIGNATURE-DOCUMENTS';
  public messageErrorRequest = '';
  // Mensaje que se mostrara si tiene una solicitud de validación de documentos.
  public messageRequest: string;
  public signCompleted = false;
  // identificador para saber si es el ultimo firmante.
  public isLastOperator: boolean;
  public urlStream;
  public resourceList: any[] = [];
  public loadingSign = false;
  public hasMultipleAttachments = false;
  public rubricSrc: string | ArrayBuffer;
  public pwfile: string | SafeStyle;
  public rffile: string | SafeStyle;
  public previewRubricWidth = '80';
  public reloadingPdf = false;
  public codeOTP: string;
  public codeSent = false;
  private addedRubric = false;
  public uanatacaRequestId: number;
  public solcertRequestId: number;
  public username: string;
  public usernameOriginal: string;
  public password: string;
  public pin: string;
  public identityValidation1 = false;
  public completeData = false;
  public hasImagesDocument = false;
  // Persona validada segun el solcert.
  public isValidPerson = false;
  // Estado de la solcitud de validación de documentos.
  public stateIdSolcert: number;
  public hasPersonConfirmation: boolean;
  // Bbservacion de la solicitud de validación de documentos.
  public observation: string;
  // Descripción del estado de la solicitud de validación.
  public stateDescription: string;
  public needRubric = false;
  public enableOTP = false;
  public documentFrontSrc: string | ArrayBuffer;
  public documentRearSrc: string | ArrayBuffer;
  public cloudSignature = TypeSignature.CLOUD;
  public remoteSignature = TypeSignature.REMOTE;
  public countryIdSelected: number;
  public countries: any[] = [];
  public signatureDescriptions: any[] = [];
  public selectedSignatureDescriptions: any[] = [];
  public reasonForSigning: string;
  public certificateDueDate: string;
  private readonly DEFAULT_COUNTRY = 168;
  public viewPassword: boolean;
  public viewPin: boolean;
  public readonly PASSWORD = 1;
  public readonly PIN = 2;
  // Lista que almacena las posiciones de las rubricas de cada PDF.
  private positionRubrics: any[];
  public resource: Resource;
  public hasConfigBalance: boolean;
  public urlPowerValidity: any;
  public urlRUCFile: any;
  public hasPowerValidity = false;
  public hasRUCFile = false;
  public resourcesChecked: any[] = [];
  public confirmRubricPosition: boolean;
  public eventsSubject: Subject<void> = new Subject<void>();
  public POWER_VALIDITY = PersonDocumentType.POWER_VALIDITY;
  public RUC_FILE = PersonDocumentType.RUC_FILE;
  private geolocation: GeolocationIofesign;
  private longitude = null;
  private latitude = null;
  private accuracy = null;
  public message = this.translate.instant('MESSAGE.NEED-ADD-IMAGES');
  public message1 = this.translate.instant('MESSAGE.NEED-OTP-FOR-SIGN');
  secondLeft = 0;
  private intervalCountDown: any;

  constructor(private activatedRoute: ActivatedRoute,
              private sanitizer: DomSanitizer,
              private cdref: ChangeDetectorRef,
              private personService: PersonService,
              private documentService: DocumentService,
              private uanatacaService: UanatacaService,
              private signService: SignService,
              private modalService: NgbModal,
              private ngZone: NgZone,
              private formBuilder: FormBuilder,
              private translate: TranslateService,
              private applicationService: ApplicationService,
              private geolocationService: GeolocationService,
              private publicService: PublicService) {
    localStorage.clear();
    Dialog.createInstance(modalService);
    this.createForm();
    this.receiveParams();
  }

  public receiveParams() {
    this.activatedRoute.params.subscribe(params => {
      this.hashIdentifier = params.hashIdentifier;
      this.personId = +params.personId;
    });
    this.getCurrentLocation();
  }

  ngOnInit() {
    this.loadPersonData(this.personId);
    LocalStorage.removeItem('selectedSignatureDescriptions');
  }

  private loadPersonData(personId: number) {
    this.loading = true;
    const urlPerson = Constant.ROOT_API_V1.concat('/public/documents/')
      .concat(this.hashIdentifier)
      .concat('/people/').concat(String(personId));
    this.personService.get(urlPerson).subscribe((next: Person) => {
      this.loading = false;
      this.person = next;
      this.loadLogoEnterprise(next.enterpriseId);
      this.wrongRequestPerson = false;
      this.loadDocumentData(this.hashIdentifier);
    }, error => {
      this.loading = false;
      this.wrongRequestPerson = true;
      if (error.status) {
        if (HttpStatusCode.NOT_FOUND === error.status || HttpStatusCode.REQUEST_TIMEOUT === error.status) {
          this.messageErrorRequest = error.error.message;
        } else {
          Dialog.show(InformType.Danger, this.translate.instant('TITLE.SIGNATURE-DOCUMENTS'));
        }
      }
    });
  }

  /**
   * Evalua si la persona ha sido evaluada y rechazada por los operadores del solcert.
   */
  public isInvalidPersonByValidityPeriod(document: Document) {
    return !document._more.validPerson && document._more.stateSolcert === StateSolcert.ATTEND;
  }

  private loadDocumentData(hashIdentifier: string) {
    this.loading = true;
    const urlDocument = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/hashIdentifier/', hashIdentifier, '/documents');
    this.personService.get(urlDocument).subscribe((next: Document) => {
      this.loading = false;
      this.document = next;
      this.hasConfigBalance = this.document._more.hasConfigBalance;
      if (TypeSignature.ELECTRONIC === this.document._more.typeSignature && this.document._more.hasRubricSettings && !this.document.closedStamping && this.person._more.rubricFilename === undefined) {
        /* this.signatureForm.get('rubricFilename2Show').setValidators(Validators.required);
         this.signatureForm.get('rubricFilename2Show').updateValueAndValidity();*/
      } else {
        if (TypeSignature.DIGITAL === this.document._more.typeSignature && this.document._more.hasRubricSettings) {
          if (this.document._more.base64RubricFile === null || this.document._more.base64RubricFile === undefined) {
            this.addedRubric = false;
          } else {
            this.addedRubric = true;
          }
          if (this.document._more.dragRubric) {
            this.getListSignatureDescriptionFromDB();
          }
        } else {
          this.addedRubric = true;
        }
      }
      if (this.hasIdentityValidation) {
        this.openModalSignDocumentInternal3();
      }
      if (this.isCloudSignature) {
        this.codeSent = this.document._more.codeOTPActive;
        this.uanatacaRequestId = this.document._more.uanatacaRequestId;
        this.solcertRequestId = this.document._more.solcertRequestId;
        this.hasImagesDocument = this.document._more.hasImagesDocument;
        this.needRubric = this.document._more.needRubric;
        this.isValidPerson = this.document._more.validPerson;
        this.stateIdSolcert = this.document._more.stateSolcert;
        this.hasPersonConfirmation = this.document._more.hasPersonConfirmation;
        this.observation = this.document._more.observationSolcert && !this.isInvalidPersonByValidityPeriod(this.document) ? this.translate.instant('LABEL.MOTIVE') + this.document._more.observationSolcert : '';
        this.stateDescription = StateSolcert.CREATE === this.stateIdSolcert ? this.translate.instant('LABEL.PENDING') : this.isInvalidPersonByValidityPeriod(this.document) ? this.translate.instant('MESSAGE.YOU-HAVE-EXCEEDED-THE-VALIDITY-TIME-LIMIT') : this.translate.instant('MESSAGE.REJECTED');
        this.messageRequest = 'Estado de validación: ' + this.stateDescription + '<br>' + this.observation;
        this.needRubric = this.document._more.needRubric;
        if (this.isInvalidPersonByValidityPeriod(this.document)) {
          this.invalidPersonConfirmation = true;
        }
        if (StateSolcert.ATTEND === this.stateIdSolcert && !this.isInvalidPersonByValidityPeriod(this.document) || !this.stateIdSolcert) {
          this.wrongRequestPersonSolcert = false;
        }
        if (StateSolcert.CREATE === this.stateIdSolcert || this.isInvalidPersonByValidityPeriod(this.document)) {
          this.wrongRequestPersonSolcert1 = true;
        }
        if (this.isValidPerson) {
          this.completeData = true;
          this.signatureForm.get('codeOTP').setValidators(
            Validators.compose(
              [
                Validators.required,
                Validators.pattern('^[0-9]{6}')])
          );
          this.signatureForm.get('codeOTP').updateValueAndValidity();
        } else {
          if (!this.hasImagesDocument) {
            this.signatureForm.get('documentFrontFilename2Show').setValidators(Validators.required);
            this.signatureForm.get('documentFrontFilename2Show').updateValueAndValidity();
            this.signatureForm.get('documentRearFilename2Show').setValidators(Validators.required);
            this.signatureForm.get('documentRearFilename2Show').updateValueAndValidity();
          }
          if (this.document._more.typePersonId === Constant.LEGAL_PERSON) {
            if (!this.document._more.hasPowerValidity) {
              this.signatureForm.get('filename2Show').setValidators(Validators.required);
              this.signatureForm.get('filename2Show').updateValueAndValidity();
            } else {
              this.signatureForm.get('filename2Show').setValue('Vigencia de poder.pdf');
            }
            if (!this.document._more.hasRUCFile) {
              this.signatureForm.get('rucFilename2Show').setValidators(Validators.required);
              this.signatureForm.get('rucFilename2Show').updateValueAndValidity();
            } else {
              this.signatureForm.get('rucFilename2Show').setValue('Ficha RUC.pdf');
            }
          }
          if (this.needRubric) {
            this.signatureForm.get('rubricFilename2Show').setValidators(Validators.required);
            this.signatureForm.get('rubricFilename2Show').updateValueAndValidity();
          }
        }
      } else {
        this.wrongRequestPersonSolcert = false;
      }
      if (this.isRemoteSignature) {
        this.getListCountry();
        this.signatureForm.get('username').setValidators(Validators.required);
        this.signatureForm.get('password').setValidators(Validators.required);
        this.signatureForm.get('pin').setValidators(Validators.required);
        this.signatureForm.get('username').updateValueAndValidity();
        this.signatureForm.get('password').updateValueAndValidity();
        this.signatureForm.get('pin').updateValueAndValidity();
      }
      this.resourceList = this.document._more.resources;
      this.hasMultipleAttachments = this.document._more.resources.length > 1;
      this.loadRubricSrc(this.document);
      this.loadFrontSrc(this.document);
      this.loadRearSrc(this.document);
      this.createEntities();
      this.resource = this.document._more.resources[0];
      this.setUrlDoc(this.resource);
      this.wrongRequestDocument = false;
    }, error => {
      this.loading = false;
      this.wrongRequestDocument = true;
      if (HttpStatusCode.FOUND === error.status) {
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.ONESIGN-SIGNATURE'), error.error.message);
        this.messageErrorRequest = error.error.message;
        return;
      }
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.SIGNATURE-DOCUMENTS'));
    });
  }

  /**
   * Obtiene la descripcciones de firma digital para ser enviadas al componente de firma.
   */
  public getSignatureDescription(): string {
    this.selectedSignatureDescriptions = LocalStorage.getSelectedSignatureDescriptions();
    if (this.selectedSignatureDescriptions) {
      this.signatureDescriptions = this.selectedSignatureDescriptions;
    }
    let value = '';
    for (const signatureDescription of this.signatureDescriptions) {
      if (signatureDescription.initialized) {
        value += ''
          .concat(signatureDescription.description)
          .concat('%0A');
      }
    }
    value = value.replace('<RUC>', this.person._more.enterpriseDocumentNumber);
    value = value.replace('<ENTERPRISE>', this.person._more.enterpriseName);
    // Se codificara el caracter especial '&' para evitar problemas con el componente de firma
    value = value.replace('&', '%26');
    return StringUtil.removeCharacter(value, 3);
  }

  public getUrlSign(document: any): SafeUrl {
    if (this.hasMultipleAttachments) {
      return;
    }
    const urlFrom = DocumentUtil.buildUrlDownload(document, this.personId);
    const urlTo = DocumentUtil.buildUrlUpload(document, this.personId);
    // Si es que tiene configurado el estapando de fecha y hora, se enviará al componente RC para la firma.
    if (document._more.stampdatetime) {
      const stampdatetime: Stampdatetime = document._more.stampdatetime;
      return 'rsign:?from='
        .concat(urlFrom)
        .concat('&to=')
        .concat(urlTo)
        .concat('&vis_sig_x=')
        .concat(String(stampdatetime.positionX))
        .concat('&vis_sig_y=')
        .concat(String(stampdatetime.positionY))
        .concat('&vis_sig_width=')
        .concat(String(stampdatetime.widthContainer))
        .concat('&vis_sig_height=')
        .concat(String(stampdatetime.heightContainer))
        .concat('&vis_sig_text=')
        .concat(stampdatetime.description)
        .concat('&vis_sig_page=')
        .concat(String(stampdatetime.stampOn));
    }
      // Si es que tiene configurado el arrastre de rubrica, se enviará al componente RC para la firma y para insertar
    // la imagen en esta misma y agregar datos del certificado.
    else if (this.hasConfigDragRubric) {
      const description = this.getSignatureDescription();
      const stampOn = this.positionRubrics[0].page === 0 ? 1 : this.positionRubrics[0].page;
      return 'rsign:?from='
        .concat(urlFrom)
        .concat('&to=')
        .concat(urlTo)
        .concat('&vis_sig_x=')
        .concat(String(this.positionRubrics[0].positionX))
        .concat('&vis_sig_y=')
        .concat(String(this.positionRubrics[0].positionY))
        .concat('&vis_sig_width=')
        .concat(String(this.positionRubrics[0].positionXf))
        .concat('&vis_sig_height=')
        .concat(String(this.positionRubrics[0].positionYf))
        .concat('&vis_sig_text=')
        .concat(description)
        .concat('&vis_sig_page=')
        .concat(String(stampOn))
        .concat('&vis_sig_image=')
        .concat(String(Constant.ROOT_API_V1 + '/public/people/' + this.personId + '/rubrics'));
    }
    return 'rsign:?from='
      .concat(urlFrom)
      .concat('&to=')
      .concat(urlTo);
  }

  public signBatchBy() {
    if (this.document._more.hasRubricSettings && !this.addedRubric) {
      Dialog.show(InformType.Warning, this.translate.instant('TITLE.SIGNATURE-DOCUMENTS'), this.translate.instant('MESSAGE.YOU-MUST-UPDATE-YOUR-RUBRIC'));
      return;
    }
    if (this.acceptRubricPlacementChecked && this.incompleteResources()) {
      this.openModalMessageAlert();
      return;
    }
    if (this.hasConfigDragRubric) {
      this.saveStamprubrictemporary();
    } else {
      if (this.hasConfigBalance) {
        this.verifyUserBalance();
      } else {
        this.sendToSign4TypeSignature();
      }
    }
  }

  // TODO correct pass parameters, services shouldn't build urls
  public checkStatusOne2One() {
    if (this.hasConfigDragRubric) {
      this.saveStamprubrictemporary();
    } else {
      if (this.hasConfigBalance) {
        this.verifyUserBalance();
      } else {
        this.sendToSign4TypeSignature();
      }
    }
  }

  /**
   * Evalua el estado de firma remota.
   */
  public checkStatusOne2OneForSignatureRemote(document: Document) {
    this.title = this.translate.instant('TITLE.SIGNATURE-DOCUMENTS');
    const urlOne2One = Constant.ROOT_API_V1.concat('/public/uanataca/signs/one2one/status')
      .concat('?personId=')
      .concat(String(this.personId))
      .concat('&documentId=')
      .concat(String(document.id));
    this.loading = true;
    const interval = setInterval(() => {
      this.documentService.get(urlOne2One).subscribe((next: any) => {
        if (next.completed === Constant.FINISHED) {
          this.signCompleted = true;
          const documents = [];
          documents.push(document);
          this.saveGeolocation(documents, this.personId, 'Firma remota');
          Dialog.show(InformType.Success, this.title);
          clearInterval(interval);
          this.loading = false;
        }
      }, error => {
        this.loading = false;
        if (HttpStatusCode.FORBIDDEN === error.status) {
          Dialog.show(InformType.Warning, this.translate.instant('TITLE.REMOTE-SIGNATURE'), error.error.message);
          clearInterval(interval);
        } else {
          Dialog.show(InformType.Danger, this.title);
          clearInterval(interval);
        }
      });
    }, 2000);
  }

  public setUrlDoc(resource: any) {
    this.resource = resource;
    this.getStream();
  }

  /**
   * Obtiene el pdf desde el API y crea un objeto con este mismo.
   */
  public getStream(): void {
    if (!this.signCompleted || this.isLastOperator) {
      this.reloadingPdf = true;
      const url = this.resource.url;
      this.documentService.download(url).subscribe(value => {
        // @ts-ignore
        const file = new Blob([value], {type: 'application/pdf'});
        this.urlStream = URL.createObjectURL(file);
        this.reloadingPdf = false;
      }, () => {
        this.reloadingPdf = false;
      });
    } else {
      this.reloadingPdf = true;
      this.urlStream = this.resource.url;
      this.reloadingPdf = false;
    }
  }

  public opensignElectronicallyModal(document: Document) {
    const modalRef = this.modalService.open(ConfirmComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.title = this.translate.instant('TITLE.SIGN-DOCUMENT');
    modalRef.componentInstance.body = this.translate.instant('QUESTION.PROCEED-WITH-SIGNING-DOCUMENT');
    modalRef.result.then(value => {
      if (Response.Yes === value) {
        const documents: Document[] = [document];
        this.signElectronically(documents);
      }
    });
  }

  /**
   * Usado para abrir el popup de confirmación segun el tipo de firma (ONESHOT O SIGNBOX)
   * @param document: documentos a firmar
   */
  public opensignModal(document: Document, typeSignature: number) {
    if (this.signatureForm.invalid) {
      Object.values(this.signatureForm.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }

    if (this.confirmRubricPosition && this.incompleteResources()) {
      Dialog.show(InformType.Warning, this.translate.instant('TITLE.RUBRIC-POSITION-CONFIRM'), this.translate.instant('MESSAGE.WARNING-CONFIRM-RUBRIC-POSITION'));
      return;
    }

    const modalRef = this.modalService.open(ConfirmComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.title = this.translate.instant('TITLE.SIGN-DOCUMENT');
    modalRef.componentInstance.body = this.translate.instant('QUESTION.PROCEED-WITH-SIGNING-DOCUMENT');
    modalRef.result.then(value => {
      if (Response.Yes === value) {
        const documents: Document[] = [document];
        if (TypeSignature.CLOUD === typeSignature) {
          this.signInCloud(documents);
        } else {
          this.signBox(documents);
        }
      }
    });
  }

  public signElectronically(documents: Document[]) {
    if (this.signatureForm.invalid) {
      Object.values(this.signatureForm.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }
    if (this.document._more.hasRubricSettings && !this.addedRubric) {
      Dialog.show(InformType.Warning, this.translate.instant('TITLE.SIGNATURE-DOCUMENTS'), this.translate.instant('MESSAGE.CLICK-ON-UPDATE-RUBRIC'));
      return;
    }
    if (this.acceptRubricPlacementChecked && this.incompleteResources()) {
      this.openModalMessageAlert();
      return;
    }
    if (this.hasConfigDragRubric) {
      this.saveStamprubrictemporary(documents);
    } else {
      if (this.hasConfigBalance) {
        this.verifyUserBalance();
      } else {
        this.sendToSign4TypeSignature(documents);
      }
    }
  }

  /**
   * Verifica si el usuario tiene el saldo suficiente para realizar esta acción
   */
  public verifyUserBalance() {
    this.loading = true;
    const documents: Document[] = [this.document];
    const url = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/documents/verify/userbalance?uuid=', this.document._more.uuid);
    this.documentService.verifyUserBalanceOrDemoNotcer(url, documents).subscribe(() => {
      this.sendToSign4TypeSignature(documents);
    }, error => {
      this.loading = false;
      if (HttpStatusCode.UPGRADE_REQUIRED === error.status) {
        Dialog.show(InformType.Warning, this.translate.instant('TABLE.HEADER.BALANCE-IOF'), error.error.message);
        return;
      }
      this.signCompleted = false;
      Dialog.show(InformType.Danger, this.title);
    });
  }

  openRCDSignatureOne2One(document: Document): void {
    const rsignUrl = this.getUrlSign(document).toString();
    window.open(rsignUrl, '_self');
  }

  /**
   * Firma documentos segun su tipo.
   * @param documents
   */
  public sendToSign4TypeSignature(documents?: Document[]) {
    if (this.acceptRubricPlacementChecked && this.incompleteResources()) {
      this.openModalMessageAlert();
      return;
    }
    let url;
    this.title = this.translate.instant('TITLE.SIGNATURE-DOCUMENTS');
    switch (this.document._more.typeSignature) {
      case TypeSignature.DIGITAL:
        if (this.hasMultipleAttachments) {
          const identifiers = String(this.document.id);
          this.signService.getUUID(this.personId, identifiers).subscribe((next: any) => {
            const fromUrl = Constant.ROOT_API_V1
              .concat('/public/signs/batch/stream?uuid=')
              .concat(next.uuid);
            const rsignUrl = 'rsign:?batch_csv='.concat(fromUrl);
            window.open(rsignUrl, '_self');

            const checkStatusBatchUrl = Constant.ROOT_API_V1
              .concat('/public/signs/batch/status')
              .concat('?uuid=')
              .concat(next.uuid)
              .concat('&personId=')
              .concat(String(this.personId));
            this.loadingSign = true;
            const interval = setInterval(() => {
              this.documentService.get(checkStatusBatchUrl).subscribe((next2: any) => {
                if (next2.completed === Constant.FINISHED) {
                  this.signCompleted = true;
                  this.getStream();
                  this.saveGeolocation(documents, this.personId, 'Firma digital');
                  Dialog.show(InformType.Success, this.title);
                  clearInterval(interval);
                  this.loadingSign = false;
                  this.loading = false;
                }
              }, () => {
                Dialog.show(InformType.Danger, this.title);
              });
            }, 3000);
          }, () => {
            Dialog.show(InformType.Danger, this.title);
          });
        } else {
          this.openRCDSignatureOne2One(this.document);
          const urlOne2One = Constant.ROOT_API_V1.concat('/public/signs/one2one/status')
            .concat('?personId=')
            .concat(String(this.personId))
            .concat('&documentId=')
            .concat(String(this.document.id));
          this.loading = true;
          const interval = setInterval(() => {
            this.documentService.get(urlOne2One).subscribe((next: any) => {
              if (next.completed === Constant.FINISHED) {
                clearInterval(interval);
                this.signCompleted = true;
                this.loading = false;
                this.loadingSign = false;
                Dialog.show(InformType.Success, this.title);
                this.getStream();
                this.saveGeolocation(documents, this.personId, 'Firma digital');
                Dialog.show(InformType.Success, this.title);
              }
            }, () => {
              Dialog.show(InformType.Danger, this.title);
            });
          }, 2000);
        }
        break;
      case TypeSignature.ELECTRONIC:
        if (this.hasIdentityValidation) {
          if (this.identityValidation1) {
            this.signElectronic(documents);
          } else {
            Dialog.show(InformType.Warning, this.translate.instant('TITLE.IDENTITY-VALIDATION'), 'Usted no realizo la validación de identidad');
          }
        } else {
          this.signElectronic(documents);
        }
        break;
      case TypeSignature.REMOTE:
        this.loading = true;
        url = Constant.ROOT_API_V1.concat('/uanataca/public/people/', String(this.personId))
          .concat('/username/', String(this.username))
          .concat('/password/', String(this.password))
          .concat('/pin/', String(this.pin))
          .concat('/documents/sign')
          .concat('?uuid=', this.document._more.uuid)
          .concat('&countryId=')
          .concat(String(this.countryIdSelected))
          .concat('&reason=')
          .concat(String(this.reasonForSigning));
        this.uanatacaService.post(url, documents).subscribe(value => {
          if (value) {
            this.loading = false;
            this.checkStatusOne2OneForSignatureRemote(this.document);
            this.getStream();
          }
        }, error => {
          this.loading = false;
          this.signCompleted = false;
          if (HttpStatusCode.FORBIDDEN === error.status) {
            Dialog.show(InformType.Warning, this.translate.instant('TITLE.REMOTE-SIGNATURE'), error.error.message);
          } else if (HttpStatusCode.INTERNAL_SERVER_ERROR === error.status) {
            Dialog.show(InformType.Danger, this.translate.instant('TITLE.REMOTE-SIGNATURE'), error.error.message);
          } else if (HttpStatusCode.UPGRADE_REQUIRED === error.status) {
            Dialog.show(InformType.Warning, this.translate.instant('TITLE.REMOTE-SIGNATURE'), error.error.message);
            return;
          } else {
            Dialog.show(InformType.Danger, this.title);
          }
        });
        break;
      case TypeSignature.CLOUD:
        this.loading = true;
        url = Constant.ROOT_API_V1.concat('/public/uanataca/requests/', String(this.uanatacaRequestId), '/codeotp/', this.codeOTP, '/documents/sign?uuid=', this.document._more.uuid);
        this.uanatacaService.post(url, documents).subscribe(value => {
          if (value) {
            Dialog.show(InformType.Success, this.title);
            this.signCompleted = true;
            this.saveGeolocation(documents, this.personId, 'Firma OneSign');
            this.getStream();
            this.loading = false;
          }
        }, error => {
          this.loading = false;
          this.signCompleted = false;
          if (HttpStatusCode.FORBIDDEN === error.status) {
            Dialog.show(InformType.Warning, 'OneSign', error.error.message);
          } else if (HttpStatusCode.INTERNAL_SERVER_ERROR === error.status) {
            Dialog.show(InformType.Danger, 'OneSign', error.error.message);
          } else if (HttpStatusCode.UPGRADE_REQUIRED === error.status) {
            Dialog.show(InformType.Warning, 'OneSign', error.error.message);
            return;
          } else if (HttpStatusCode.FOUND === error.status) {
            Dialog.show(InformType.Warning, 'OneSign', error.error.message);
            return;
          } else {
            Dialog.show(InformType.Danger, this.title);
          }
        });
        break;
    }
  }

  public signInCloud(documents: Document[]) {
    if (this.hasConfigDragRubric) {
      this.saveStamprubrictemporary(documents);
    } else {
      if (this.hasConfigBalance) {
        this.verifyUserBalance();
      } else {
        this.sendToSign4TypeSignature(documents);
      }
    }
  }

  public signElectronic(documents?: Document[]) {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/documents/sign?uuid=', this.document._more.uuid);
    this.documentService.signElectronically(url, documents).subscribe(() => {
      this.loading = false;
      this.signCompleted = true;
      this.saveGeolocation(documents, this.personId, 'Firma gráfica');
      this.isDocumentFinished(this.document.id);
      Dialog.show(InformType.Success, this.title);
    }, error => {
      this.loading = false;
      if (HttpStatusCode.UPGRADE_REQUIRED === error.status) {
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.SIGN'), error.error.message);
        return;
      }
      this.signCompleted = false;
      Dialog.show(InformType.Danger, this.title);
    });
  }

  public openModalSignDocumentInternal3() {
    const modalRef = this.modalService.open(IdentityValidationComponent, {
      backdrop: 'static',
      size: 'lg',
      animation: true,
      keyboard: false
    });
    this.person.documentId = this.document.id;
    modalRef.componentInstance.person = this.person;
    modalRef.componentInstance.isPublic = true;
    modalRef.componentInstance.document = this.document;
    modalRef.result.then((result) => {
      const informType = result.informType;
      if (InformType.Success === informType) {
        Dialog.show(InformType.Success, this.translate.instant('TITLE.IDENTITY-VALIDATION'), 'Validación de identidad correcta');
        this.reloadPdf();
        this.identityValidation1 = true;
      }
      if (InformType.Anything === informType) {
      }
      this.loading = false;
    }, reason => {
      if (reason === ModalDismissReasons.ESC) {
      }
    });
  }

  public signBox(documents: Document[]) {
    if (this.hasConfigDragRubric) {
      this.saveStamprubrictemporary(documents);
    } else {
      if (this.reasonForSigning === undefined) {
        this.reasonForSigning = '';
      }
      if (this.hasConfigBalance) {
        this.verifyUserBalance();
      } else {
        this.sendToSign4TypeSignature(documents);
      }
    }
  }

  get digitalSignature(): boolean {
    return TypeSignature.DIGITAL === this.document._more.typeSignature;
  }

  get electronicSignature(): boolean {
    return TypeSignature.ELECTRONIC === this.document._more.typeSignature;
  }

  public readSelectedRubric(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => this.rubricSrc = reader.result;
      reader.readAsDataURL(file);
    }
  }

  public changeStatus(event: any) {
    const testFile = event[Constant.ZERO_INDEX];
    this.signatureForm.patchValue({
      rubricFileBase64: testFile.base64,
      rubricFilename: testFile.name,
      rubricFilename2Show: StringUtil.cut(testFile.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.updateValueAndValidityRubricFields();
    this.updateRubric();
  }

  private updateValueAndValidityRubricFields() {
    this.signatureForm.get('rubricFileBase64').updateValueAndValidity();
    this.signatureForm.get('rubricFilename').updateValueAndValidity();
    this.signatureForm.get('rubricFilename2Show').updateValueAndValidity();
  }

  get defaultRubricSrc(): string | ArrayBuffer {
    return this.rubricSrc || this.placeHoldItRubric;
  }

  get placeHoldItRubric(): string {
    return Constant.DEFAULT_IMAGE_PATH_80_40;
  }

  public createForm() {
    this.signatureForm = this.formBuilder.group(
      {
        rubricFileId: [''],
        groupRadio: [''],
        page: [''],
        resource: [''],
        anotherPage: [''],
        rubricFileBase64: [''],
        rubricFilename: [''],
        rubricFilename2Show: [''],
        codeOTP: [''],
        documentFrontFileBase64: [''],
        documentFrontFilename: [''],
        documentFrontFilename2Show: [''],
        documentRearFileBase64: [''],
        documentRearFilename: [''],
        documentRearFilename2Show: [''],
        file: [''],
        filename: [''],
        filename2Show: [''],
        rucFile: [''],
        rucFilename: [''],
        rucFilename2Show: [''],
        username: [''],
        password: [''],
        pin: [''],
        uanatacasignaturelevel: [''],
        country: [''],
        reason: [''],
        pagesTotal: [''],
      });
  }

  get styleDimensionsRubric(): string {
    return 'width: ' + this.previewRubricWidth + 'px; height: auto';
  }

  public readSelectedDocumentFront(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => this.documentFrontSrc = reader.result;
      reader.readAsDataURL(file);
    }
  }

  public readSelectedBackDNI(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => this.documentRearSrc = reader.result;
      reader.readAsDataURL(file);
    }
  }

  get hasIdentityValidation(): boolean {
    return this.document._more.hasIdentityValidation;
  }

  get showPdf(): boolean {
    return this.document._more.typeSignature === TypeSignature.ELECTRONIC && this.hasIdentityValidation ? this.identityValidation1 : true;
  }

  public changeStatus3(event: any) {
    const testFile = event[Constant.ZERO_INDEX];
    this.signatureForm.patchValue({
      documentFrontFileBase64: testFile.base64,
      documentFrontFilename: testFile.name,
      documentFrontFilename2Show: StringUtil.cut(testFile.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.updateValueAndValidityObverseDNIFields();
  }

  public changeStatus4(event: any) {
    const testFile = event[Constant.ZERO_INDEX];
    this.signatureForm.patchValue({
      documentRearFileBase64: testFile.base64,
      documentRearFilename: testFile.name,
      documentRearFilename2Show: StringUtil.cut(testFile.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.updateValueAndValidityBackDNIFields();
  }

  private updateValueAndValidityObverseDNIFields() {
    this.signatureForm.get('documentFrontFileBase64').updateValueAndValidity();
    this.signatureForm.get('documentFrontFilename').updateValueAndValidity();
    this.signatureForm.get('documentFrontFilename2Show').updateValueAndValidity();
  }

  private updateValueAndValidityBackDNIFields() {
    this.signatureForm.get('documentRearFileBase64').updateValueAndValidity();
    this.signatureForm.get('documentRearFilename').updateValueAndValidity();
    this.signatureForm.get('documentRearFilename2Show').updateValueAndValidity();
  }

  get defaultDocumentFrontSrc(): string | ArrayBuffer {
    return this.documentFrontSrc || this.placeHoldItRubric;
  }

  get defaultDocumentRearSrc(): string | ArrayBuffer {
    return this.documentRearSrc || this.placeHoldItRubric;
  }

  public updateRubric(): void {
    const rubricFileBase64: string = this.signatureForm.get('rubricFileBase64').value;
    const rubricFilename: string = this.signatureForm.get('rubricFilename').value;
    const url = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/rubric?uuid=', this.document._more.uuid);
    this.personService.updateRubric(url, rubricFileBase64, rubricFilename).subscribe(() => {
      this.getStream();
      this.addedRubric = true;
    }, () => {
      this.reloadingPdf = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.RUBRIC-UPDATE'));
    });
  }

  /**
   * Actualiza las imágenes del documento de identidad y las rúbricas de ser necesarias
   */
  public updateImages(): void {
    if (this.signatureForm.invalid) {
      Object.values(this.signatureForm.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }
    this.setFinalValuesBefore2Save();
    this.reloadingPdf = true;
    this.loading = true;
    const url = Constant.ROOT_API_V1
      .concat('/public/people/documentimages?uuid=', this.document._more.uuid)
      .concat('&documentId=', String(this.document.id));
    this.personService.update(url, this.person).subscribe(() => {
      this.loading = false;
      this.reloadingPdf = false;
      if (this.isCloudSignature) {
        this.generateRequestInSolcert();
      } else {
        Dialog.show(InformType.Success, this.translate.instant('TITLE.CORRECTLY-COMPLETED-DATA'), this.translate.instant('MESSAGE.THE-OPERATION-WAS-SUCCESSFULLY-COMPLETED'));
      }
    }, () => {
      this.loading = false;
    });
  }

  /**
   * Genera solicitud de validación de persona en el solcert
   */
  public generateRequestInSolcert(): void {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/personconfirmations?uuid=', this.document._more.uuid)
      .concat('&typePerson=', String(this.document._more.typePersonId))
      .concat('&documentId=')
      .concat(String(this.document.id));
    this.personService.createRequestSolcert(url).subscribe(() => {
      Dialog.show(InformType.Success, this.translate.instant('TITLE.CORRECTLY-COMPLETED-DATA'), this.translate.instant('MESSAGE.SHORTLY-VALIDATE-INFORMATION'));
      this.loading = false;
      this.messageRequest = this.translate.instant('MESSAGE.SHORTLY-VALIDATE-INFORMATION').concat(this.translate.instant('MESSAGE.YOU-CAN-REFRESH-THIS-PAGE-TO-CHECK-STATUS-APPLICATION'));
      this.wrongRequestPersonSolcert1 = true;
      this.wrongRequestPersonSolcert = true;
      this.invalidPersonConfirmation = false;
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.CREATION-REQUEST'));
    });
  }

  public setFinalValuesBefore2Save() {
    this.person.rubricBase64Data = this.signatureForm.get('rubricFileBase64').value;
    this.person.rubricFilename = this.signatureForm.get('rubricFilename').value;
    this.person.documentFrontBase64Data = this.signatureForm.get('documentFrontFileBase64').value;
    this.person.documentFrontFilename = this.signatureForm.get('documentFrontFilename').value;
    this.person.documentRearBase64Data = this.signatureForm.get('documentRearFileBase64').value;
    this.person.documentRearFilename = this.signatureForm.get('documentRearFilename').value;
    this.person.file = this.signatureForm.get('file').value;
    this.person.filename = this.signatureForm.get('filename').value;
    this.person.rucFileBase64Data = this.signatureForm.get('rucFile').value;
    this.person.rucFilename = this.signatureForm.get('rucFilename').value;
  }

  haveDocIdentificationImages(person) {
    return person ? (person._more.documentFrontBase64Data && person._more.documentRearBase64Data) ||
      (this.document._more.documentFrontBase64Data && this.document._more.documentRearBase64Data) ||
      this.docIdentificationImagesSaved(person) : false;
  }

  docIdentificationImagesSaved(person) {
    return person ? person.documentFrontBase64Data && person.documentRearBase64Data : false;
  }

  public generateOTP() {
    const documents: Document[] = [];
    documents.push(this.document);
    this.loading = true;
    this.countDown();
    const url = Constant.ROOT_API_V1.concat('/public/uanataca/requests/', String(this.uanatacaRequestId), '/otp?uuid=', this.document._more.uuid);
    this.uanatacaService.post(url, null).subscribe(value => {
      const phoneNumber = this.document._more.phoneNumber;
      const splited = StringUtil.splitBy(phoneNumber, 3);
      this.loading = false;
      if (value) {
        this.codeSent = value;
        const btnElement = document.getElementById('btnSendOTP');
        btnElement.setAttribute('disabled', 'disabled');
        Dialog.show(InformType.Success, 'OneSign', this.translate.instant('MESSAGE.CODE-SENT-TO-CELL-PHONE') + phoneNumber.charAt(0) + '*****' + splited[splited.length - 1]);
      }
    }, error => {
      this.loading = false;
      this.signCompleted = false;
      if (error.status === HttpStatusCode.CONFLICT) {
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.SIGNATURE-DOCUMENTS'), error.error.message);
      } else {
        Dialog.show(InformType.Danger, this.translate.instant('TITLE.SIGNATURE-DOCUMENTS'));
      }
    });
  }

  public getListCountry() {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/public/countries?uuid=', this.document._more.uuid)
      .concat('&personId=')
      .concat(String(this.personId));
    this.uanatacaService.post(url, null).subscribe(value => {
      this.loading = false;
      this.countries = value;
      this.countryIdSelected = this.DEFAULT_COUNTRY;
    }, () => {
      this.loading = false;
      this.signCompleted = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.SIGNATURE-DOCUMENTS'));
    });
  }

  /**
   * Obtiene la lista de las descripcciones disponibles para mostrar en la firma digital.
   */
  public getListSignatureDescriptionFromDB() {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/public/signaturedescription?uuid=', this.document._more.uuid)
      .concat('&personId=')
      .concat(String(this.personId));
    this.documentService.post(url).subscribe(value => {
      this.loading = false;
      this.signatureDescriptions = value;
    }, () => {
      this.loading = false;
      this.signCompleted = false;
      Dialog.show(InformType.Danger, this.title);
    });
  }

  /**
   * Devuelve lista de las descripciones para ser enviadas al formulario del visor de PDF
   */
  public getListSignatureDescription(): any {
    this.selectedSignatureDescriptions = LocalStorage.getSelectedSignatureDescriptions();
    if (this.selectedSignatureDescriptions) {
      return this.selectedSignatureDescriptions;
    } else {
      return this.signatureDescriptions;
    }
  }

  public downloadContract() {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/uanataca/public/uanatacarequests/', String(this.uanatacaRequestId), '/contract/stream?uuid=', this.document._more.uuid);
    this.uanatacaService.get(url).subscribe(next => {
      const control = document.createElement('a');
      control.setAttribute('style', 'display:none;');
      document.body.appendChild(control);
      control.href = window.URL.createObjectURL(next);
      control.download = 'contrato.pdf';
      control.click();
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  public isInvalidControl(ctrlName: string) {
    return this.signatureForm.get(ctrlName).invalid && this.signatureForm.get(ctrlName).touched;
  }

  get isRemoteSignature(): boolean {
    return TypeSignature.REMOTE === this.document._more.typeSignature;
  }

  public search(data: any) {
    if (data.target.value !== this.usernameOriginal) {
      this.certificateDueDate = '';
    }
    this.uanatacasignboxdatas = [];
    const user = data.target.value;
    if (user.length > 3) {
      this.uanatacaService.search(this.personId, user).subscribe((next: any) => {
        if (next._embedded) {
          this.uanatacasignboxdatas = next._embedded.uanatacasignboxdata;
        }
      });
    }
  }

  public onSignboxDataChanged(userSelected) {
    const listElement = userSelected.split('-');
    const username = listElement[Constant.ZERO_INDEX].trim();
    this.signBoxDataSelected = this.uanatacasignboxdatas.find(value => value.user === username);
    if (this.signBoxDataSelected) {
      this.username = this.signBoxDataSelected.user;
      this.usernameOriginal = this.signBoxDataSelected.user;
      this.reasonForSigning = this.signBoxDataSelected.reason;
      this.certificateDueDate = this.signBoxDataSelected.certificateDueDate;
    }
  }

  public hasCertificateDueDate(certificateDueDate) {
    if (certificateDueDate) {
      return true;
    } else {
      return false;
    }
  }

  public toggleFieldTextType(passwordType: number) {
    if (this.PASSWORD === passwordType) {
      this.viewPassword = !this.viewPassword;
    } else if (this.PIN === passwordType) {
      this.viewPin = !this.viewPin;
    }
  }

  isCertificateDueDateCorrect(certificateDueDateCorrect: any) {
    if (certificateDueDateCorrect) {
      return new Date(certificateDueDateCorrect) > new Date();
    }
  }

  /**
   * Crea la posiciones temporales al inicio de la carga de la pagina.
   * @private
   */
  private createEntities() {
    if (this.document._more.positions) {
      this.positionRubrics = this.resourceList.map(value => {
        const position = this.document._more.positions;
        const positionSplitted = position.split(',', 6);
        const positionRubricInfo: Stamprubrictemporal = {
          resourceId: value.id,
          documentId: value.documentId,
          positionX: Number(positionSplitted[0]),
          positionY: Number(positionSplitted[1]),
          positionXf: Number(positionSplitted[2]),
          positionYf: Number(positionSplitted[3]),
          pageStamp: Number(positionSplitted[4]),
          page: Number(positionSplitted[5]),
          signaturedescriptionIds: null,
        };
        return positionRubricInfo;
      });
      LocalStorage.setItem('positionRubrics', this.positionRubrics);
    }
  }

  /**
   * Guarda las posiciones temporales de la rubrica.
   * @private
   */
  private saveStamprubrictemporary(documents?: Document[]) {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/stamprubrictemporary');
    const stamprubrictemporalinfo = new StamprubrictemporalList();
    this.getCurrentPositions();
    if (this.reasonForSigning === undefined) {
      this.reasonForSigning = '';
    }
    if (this.digitalSignature) {
      if (LocalStorage.getSelectedSignatureDescriptions()) {
        this.selectedSignatureDescriptions = LocalStorage.getSelectedSignatureDescriptions();
      } else {
        this.selectedSignatureDescriptions = this.getListSignatureDescription();
      }
      const SelectedSignatureDescription = this.selectedSignatureDescriptions.filter(value => value.initialized === true);
      const docIdentifiers = StringUtil.concatIdentifiers(SelectedSignatureDescription);
      this.positionRubrics.forEach(value => value.signaturedescriptionIds = docIdentifiers);
    }
    stamprubrictemporalinfo.stamprubrictemporals = this.positionRubrics;
    this.signService.save(url, stamprubrictemporalinfo).subscribe(() => {
      this.loading = false;
      if (this.hasConfigBalance) {
        this.verifyUserBalance();
      } else {
        this.sendToSign4TypeSignature(documents);
      }
    }, () => {
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.SIGNATURE-DOCUMENTS'));
      this.loading = false;
    });
  }

  /**
   * Obtiene las posiciones actuales de la rubrica de todos los documentos.
   * @private
   */
  private getCurrentPositions() {
    this.positionRubrics = LocalStorage.getPositionRubrics();
  }

  private loadRubricSrc(document: Document) {
    if (document && document._more.rubricFileExtension && document._more.base64RubricFile) {
      this.rubricSrc = 'data:image/' + document._more.rubricFileExtension + ';base64,' + document._more.base64RubricFile;
    } else {
      this.rubricSrc = this.placeHoldItRubric;
    }
  }

  /**
   * Carga de imagen frontal del documento de identidad.
   * @param document
   * @private
   */
  private loadFrontSrc(document: Document) {
    if (document && document._more.documentFrontFileExtension && document._more.documentFrontBase64Data) {
      this.documentFrontSrc = 'data:image/' + document._more.documentFrontFileExtension + ';base64,' + document._more.documentFrontBase64Data;
    } else {
      this.documentFrontSrc = this.placeHoldItRubric;
    }
  }

  /**
   * Carga de imagen posterior del documento de identidad.
   * @param document
   * @private
   */
  private loadRearSrc(document: Document) {
    if (document && document._more.documentRearFileExtension && document._more.documentRearBase64Data) {
      this.documentRearSrc = 'data:image/' + document._more.documentRearFileExtension + ';base64,' + document._more.documentRearBase64Data;
    } else {
      this.documentRearSrc = this.placeHoldItRubric;
    }
  }

  /*Firma gráfica con codígo de verificación o sin*/
  public signGrafic(document: any) {
    if (this.isElectronicSignature && this.haveDocumentIntegrityToGraficSign) {
      const code = this.signatureForm.get('codeOTP').value;
      if (code === '' || code === undefined) {
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.VERIFICATION-CODE'), this.translate.instant('MESSAGE.ENTER-CODE-OR-REQUEST-NEW-CODE'));
        return;
      }
      if (!this.haveDocIdentificationImages(this.person)) {
        Dialog.show(InformType.Warning, this.translate.instant('LABEL.ADD-IMAGES-OF-IDENTITY-DOCUMENT'),
          this.translate.instant('MESSAGE.ENTER-DOCUMENT-IDENTIFICATION-IMAGE-OR-UPDATE'));
        return;
      }
      const url = Constant.ROOT_API_V1 + '/public/verify-verification-code?code='.concat(code).concat('&value=').concat(this.getDocumentType(this.person.documentType).concat('_').concat(this.person.documentNumber));
      this.applicationService.get(url).subscribe((value: any) => {
        if (value.validVerificationCode) {
          const documents: Document[] = [document];
          this.signElectronically(documents);
        } else {
          Dialog.show(InformType.Danger, this.translate.instant('TITLE.VERIFICATION-CODE'), this.translate.instant('MESSAGE.OPERATION-NOT-COMPLETED-BY-INCORRECT-CODE'));
        }
      }, () => {
        Dialog.show(InformType.Danger, this.translate.instant(this.title));
      });
    } else {
      this.opensignElectronicallyModal(document);
    }
  }

  /*Verificamos si el código solicitado es para firma OneSign o firma Gráfica*/
  generateCodeOrOTP() {
    if (this.isCloudSignature) {
      this.generateOTP();
    } else if (this.isElectronicSignature && this.haveDocumentIntegrityToGraficSign) {
      this.generateCode();
    }
  }

  /*Método obtiene información necesaria del firmante para luego enviar el código de verificación para la firma grafica.*/
  generateCode() {
    const url = Constant.ROOT_API_V1.concat('/public/people?personId=').concat(String(this.person.id));
    this.applicationService.get(url).subscribe(() => {
      this.getUUID();
    });
  }

  /*Se obtiene el identificador unico universal*/
  private getUUID(): void {
    const url = Constant.ROOT_API_V1 + '/public/uuid';
    this.applicationService.get(url).subscribe((value: any) => {
      this.sendVerificationCode(value.uuid);
    }, () => {
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.OBTAINING-UUID'));
    });
  }

  /**
   * Este método registra el código y luego envía al correo del usuario para la firma del documento.
   */
  public sendVerificationCode(uuid?: string): void {
    const url = Constant.ROOT_API_V1 + '/public/send-verification-code/save/traceability';
    const formData = new FormData();
    formData.append('documentId', String(this.document.id));
    formData.append('uuid', uuid);
    formData.append('value', this.getDocumentType(this.person.documentType).concat('_').concat(this.person.documentNumber));
    formData.append('email', this.person.email);
    this.loading = true;
    this.applicationService.post(url, formData).subscribe(() => {
      this.loading = false;
      const numbers = StringUtil.splitBy(this.person.email, 3);
      const email = this.person.email.charAt(0) + this.person.email.charAt(1) + '***********' + numbers[numbers.length - 1];
      Dialog.show(InformType.Info, this.translate.instant('TITLE.VERIFICATION-CODE'), this.translate.instant('MESSAGE.SEND-VERIFICATION-CODE-TO-EMAIL').replace('P_EMAIL', email));
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.VERIFICATION-CODE'), this.translate.instant('MESSAGE.ERROR-OCCURRED-TO-SEND-VERIFICATION-CODE'));
    });
  }

  getDocumentType(documentType) {
    return Constant.DNI === Number(documentType) ? IdentificationDocument.dDNI : (Constant.CARNE_EXTRANJERIA === Number(documentType) ? IdentificationDocument.dCE : IdentificationDocument.dPAS);
  }

  /**
   * Muestra el modal signaturePad donde el usuario puede agregar o dibujar su rubrica
   */
  signaturePad() {
    const modalRef = this.modalService.open(SignaturePadComponent, {
      windowClass: 'my-class-signature-pad'
    });
    modalRef.componentInstance.isInvited = true;
    modalRef.componentInstance.personId = this.personId;
    modalRef.componentInstance.uuid = this.document._more.uuid;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.updateLastRubric();
        this.updateValueAndValidityRubricFields();
      } else if (InformType.Danger === result) {
      }
    });
  }

  /**
   * Actualiza la rubrica que es mostrada al momento de firmar.
   */
  updateLastRubric() {
    this.reloadingPdf = true;
    this.rubricSrc = LocalStorage.getRubricrubricFile();
    LocalStorage.removeItem('rubricFile');
    this.addedRubric = true;
    this.reloadingPdf = false;
    if (!this.hasDragRubric) {
      this.getStream();
    }
    this.signatureForm.get('rubricFileBase64').clearValidators();
    this.signatureForm.get('rubricFilename').clearValidators();
    this.signatureForm.get('rubricFilename2Show').clearValidators();
    this.signatureForm.get('rubricFileBase64').updateValueAndValidity();
    this.signatureForm.get('rubricFilename').updateValueAndValidity();
    this.signatureForm.get('rubricFilename2Show').updateValueAndValidity();
  }

  public readSelectedPWfile(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.pwfile = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  public readSelectedRFfile(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.rffile = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  public async changeStatus1(event) {
    const fileSelected = event[Constant.ZERO_INDEX];
    if (!fileSelected.name.endsWith('.pdf')) {
      Dialog.show(InformType.Warning, this.translate.instant('TITLE.ADD-DOCUMENT-BATCH'), this.translate.instant('MESSAGE.SELECTED-NOT-ALLOWED-FILE'));
      return;
    }
    this.signatureForm.patchValue({
      file: fileSelected.base64,
      filename: fileSelected.name,
      filename2Show: StringUtil.cut(fileSelected.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.hasPowerValidity = true;
    const r = await fetch(fileSelected.base64);
    const blob = await r.blob();
    this.urlPowerValidity = URL.createObjectURL(blob);
  }

  public async changeStatus7(event) {
    const fileSelected = event[Constant.ZERO_INDEX];
    if (!fileSelected.name.endsWith('.pdf')) {
      Dialog.show(InformType.Warning, this.translate.instant('TITLE.ADD-DOCUMENT-BATCH'), this.translate.instant('MESSAGE.SELECTED-NOT-ALLOWED-FILE'));
      return;
    }
    this.signatureForm.patchValue({
      rucFile: fileSelected.base64,
      rucFilename: fileSelected.name,
      rucFilename2Show: StringUtil.cut(fileSelected.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.hasRUCFile = true;
    const r = await fetch(fileSelected.base64);
    const blob = await r.blob();
    this.urlRUCFile = URL.createObjectURL(blob);
  }

  /**
   * Se abre el modal para la aceptación de los terminos y condiciones.
   * @param document
   * @param cloudSignature
   * @private
   */
  private openAcceptTermsConditions(document: Document, cloudSignature: any) {
    const openModal = this.modalService.open(AcceptTermsConditionsComponent, {
      backdrop: 'static'
    });
    openModal.componentInstance.requestId = this.solcertRequestId;
    openModal.result.then((informType) => {
      if (informType === InformType.Success) {
        this.registerAcceptTerm(document, cloudSignature);
      }
    });
  }

  /**
   * Este metodo verifica si el cliente acepto los terminos y condiciones para el documento,
   * @param document
   * @param typeSignature
   */
  verifyAcceptTermToSignCloud(document: any, typeSignature: any) {
    if (this.signatureForm.invalid) {
      Object.values(this.signatureForm.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }
    this.publicService.verifyAcceptTerm(this.uanatacaRequestId).subscribe((next: any) => {
      if (Boolean(next.acceptTermCondition === 'true')) {
        this.opensignModal(document, typeSignature);
      } else {
        this.openAcceptTermsConditions(document, typeSignature);
      }
    }, error => {
      Dialog.show(InformType.Danger, this.title, this.translate.instant('MESSAGE.ERROR-ACCEPT-TERMS-AND-CONDITIONS'));
    });
  }

  /**
   * Registramos los terminos y condicones aceptadas por el cliente.
   * @param document
   * @param typeSignature
   */
  registerAcceptTerm(document: any, typeSignature) {
    this.publicService.register(this.uanatacaRequestId).subscribe((next: any) => {
      if (next.acceptTermCondition) {
        this.opensignModal(document, typeSignature);
      }
    }, error => {
      Dialog.show(InformType.Danger, this.title, this.translate.instant('MESSAGE.ERROR-REGISTER-TERMS-AND-CONDITIONS'));
    });
  }

  openModalPdfViewer(typeDocumentId: number) {
    const url = Constant.ROOT_API_V1
      .concat('/public')
      .concat('/people/')
      .concat(String(this.personId))
      .concat('/persondocument/')
      .concat(String(typeDocumentId))
      .concat('/stream?uuid=', this.document._more.uuid);
    let url1;
    let tittle;
    let hasFile;
    if (PersonDocumentType.RUC_FILE === typeDocumentId) {
      tittle = 'LABEL.RUC-FILE';
      hasFile = this.document._more.hasRUCFile && !this.hasRUCFile;
      url1 = this.urlRUCFile;
    } else {
      tittle = 'LABEL.POWER-VALIDITY';
      hasFile = this.document._more.hasPowerValidity && !this.hasPowerValidity;
      url1 = this.urlPowerValidity;
    }
    if (hasFile) {
      this.personService.download(url).subscribe(value => {
        // @ts-ignore
        const file = new Blob([value], {type: 'application/pdf'});
        url1 = URL.createObjectURL(file);
        const opemModal = this.modalService.open(TermPdfViewerComponent, {
          backdrop: 'static',
          size: 'lg'
        });
        opemModal.componentInstance.urlStream = url1;
        opemModal.componentInstance.title = this.translate.instant(tittle);
      }, () => {
      });
    } else {
      const openModal = this.modalService.open(TermPdfViewerComponent, {
        backdrop: 'static',
        size: 'lg'
      });
      openModal.componentInstance.urlStream = url1;
      openModal.componentInstance.title = this.translate.instant(tittle);
    }
  }

  wasAllSelected1() {
    return this.resourcesChecked.length === this.resourceList.length;
  }

  incompleteResources() {
    const signResources = this.resourceList.filter(resource => resource.sign === true);
    return this.resourcesChecked.length !== signResources.length;
  }

  addOrRemoveAll(event: any) {
    if (event.target.checked) {
      this.resourceList.forEach(resource => {
        const resourceWasPushed = this.resourcesChecked.find(resource1 => resource.id === resource1.id);
        if (!resourceWasPushed && resource.sign) {
          const clonedResource = CloneTool.do(resource);
          this.resourcesChecked.push(clonedResource);
        }
      });
    } else {
      this.resourcesChecked = [];
    }
  }

  private isDocumentFinished(documentId: number) {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/public/verify/document/have-manifest-and-traceability/?documentId=').concat(String(documentId));
    if (this.signCompleted) {
      const interval = setInterval(() => {
        this.publicService.get(url).subscribe((next2: any) => {
          if (next2.hasConfManifestAndTraceability) {
            if (next2.documentIsReady) {
              this.loading = false;
              this.reloadPdf();
              clearInterval(interval);
            }
          } else {
            this.loading = false;
            this.getStream();
            clearInterval(interval);
          }
        });
      }, 500);
    }
    setTimeout(() => {
      this.loading = false;
    }, 5000);
    // this.publicService.get(url).subscribe((next: any) => {
    //   if (next.hasConfManifestAndTraceability) {
    //   } else {
    //     this.loading = false;
    //     this.getStream();
    //   }
    // }, error => {
    //   this.loading = false;
    // });
  }

  wasChecked(resource: any) {
    return this.resourcesChecked.find(resource1 => resource1.id === resource.id);
  }

  wasSelected2(resource1: any) {
    return this.resourcesChecked.find(resource => resource1.id === resource.id) !== undefined;
  }

  addRemoveResource(event: any, resource: any) {
    const index = this.resourcesChecked.findIndex(resource1 => resource.id === resource1.id);
    if (event.target.checked) {
      const clonedResource = CloneTool.do(resource);
      const resourcePushed = this.resourcesChecked.find(resource1 => resource.id === resource1.id);
      if (!resourcePushed && resource.sign) {
        this.resourcesChecked.push(clonedResource);
      }
    } else {
      this.resourcesChecked.splice(index, 1);
    }
  }

  cutFileName(fileName: string) {
    const maxLength = 30;
    return fileName.length > maxLength ? fileName.substring(0, 10) + ' .... ' + fileName.substring(fileName.length - 15) : fileName;
  }

  /**
   * Detecta que se realizó la reubicación de la rúbrica y se marca con un check para confirmar la ubicación de la rubrica
   * @param resource
   */
  rubricDragEnd(resource: any) {
    const resourceWasPushed = this.resourcesChecked.find(resource1 => resource.id === resource1.id);
    if (!resourceWasPushed && resource.sign) {
      const clonedResource = CloneTool.do(resource);
      this.resourcesChecked.push(clonedResource);
    }
    this.wasChecked(resource);
    this.wasSelected2(resource);
  }

  private openModalMessageAlert() {
    let fileName = '';

    function BreakException(message) {
      this.message = message;
      this.name = 'Exception';
    }

    this.resourceList.forEach(resource => {
      const resourcePushed = this.resourcesChecked.find(resource1 => resource.id === resource1.id);
      if (!resourcePushed && resource.sign) {
        fileName = resource.fileName;
        const message = this.translate.instant('MESSAGE.WARNING-CONFIRM-RUBRIC-POSITION').replace('P_DOCUMENT_NAME', '"' + fileName.bold() + '"');
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.RUBRIC-POSITION-CONFIRM'), message);
        this.loading = false;
        throw new BreakException('Detener el recorrido');
      }
    });
  }


  /**
   * Obtenemos la goelocalización del usuario firmante.
   * @private
   */
  private getCurrentLocation() {
    const url = Constant.ROOT_API_V1.concat('/ip_address/');
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.longitude = position.coords.longitude;
        this.latitude = position.coords.latitude;
        this.accuracy = position.coords.accuracy;
      }, error => {
        this.longitude = null;
        this.latitude = null;
        this.accuracy = null;
      });
      this.applicationService.setIpLocalStorage(url);
    }
  }

  private saveGeolocation(documents: Document[], personId: number, signatureType: string) {
    // tslint:disable-next-line:prefer-for-of
    for (let index = 0; index < documents.length; index++) {
      const date = new Date(Date.now());
      const documentId = documents[index].id;
      this.geolocation = this.setValueGeolocation(documentId, personId);
      this.geolocation.signatureType = signatureType;
      this.geolocation.longTime = Date.now().toString();
      this.geolocation.timeStamp = date.toString();
      this.geolocation.timeZone = this.getGMT(date);
      this.geolocation.identification = null;
      this.geolocationService.save(this.geolocation).subscribe(resp => {

      }, error => {
        Dialog.show(InformType.Danger, 'Localización', 'No se pudo guardar su ubicación.');
      });
    }
  }

  private setValueGeolocation(documentId: number, personId: number) {
    this.geolocation = new GeolocationIofesign();
    this.geolocation.latitude = String(this.latitude);
    this.geolocation.longitude = String(this.longitude);
    this.geolocation.accuracy = String(this.accuracy);
    this.geolocation.documentId = documentId;
    this.geolocation.personId = personId;
    this.geolocation.ip = LocalStorage.getIpAddress();
    return this.geolocation;
  }

  private getGMT(date: Date) {
    return date.toTimeString().split(' ')[1];
  }

  /**
   * Se obtiene el logo de la empresa para ser mostrado cuando el invitado abra el enlace para la firma o rivisión del documento
   * @param enterpriseId
   * @private
   */
  private loadLogoEnterprise(enterpriseId: number) {
    const url = Constant.ROOT_API_V1.concat('/public/enterprise/').concat(String(enterpriseId)).concat('/logo');
    this.publicService.get(url).subscribe(next => {
      localStorage.setItem('enterpriseLogoBase64', next.data);
      localStorage.setItem('logoFileExtension', next.extension);
    }, error => {
      console.log('Error no se pudo obtener el logo de la empresa.');
    });
  }

  get isInvited(): boolean {
    return Constant.INVITED === this.person._more.participantType;
  }

  get description4button(): string {
    return this.isCloudSignature ? 'BUTTON.REQUEST-CERTIFICATE' : 'BUTTON.UPDATE-IMAGES';
  }

  get hasConfigDragRubric(): boolean {
    return !this.isCloseStampingAndIsNotDigitalSignature && !this.signCompleted && this.hasConfigRubric && this.hasDragRubric;
  }

  /**
   * Valida si necesita mostrar los contenedores de las imagenes de documento.
   */
  get needShowImages(): boolean {
    if (!this.hasPersonConfirmation) {
      return true;
    }
    if (this.stateIdSolcert) {
      return StateSolcert.REFUSED === this.stateIdSolcert || !this.hasImagesDocument;
    }
    return !this.hasImagesDocument;
  }

  get needShowPowerValidityAndRucFile(): boolean {
    return (this.document._more.typePersonId === Constant.LEGAL_PERSON);
  }

  get hasConfigRubric(): boolean {
    if (this.document !== undefined) {
      return this.document._more.hasRubricSettings;
    }
  }

  get hasDragRubric(): boolean {
    return this.document._more.dragRubric;
  }

  get isCloseStampingAndIsNotDigitalSignature(): boolean {
    if (this.document !== undefined) {
      return this.document.closedStamping && !this.digitalSignature && !this.isCloudSignature && !this.isRemoteSignature;
    }
  }

  get isCloudSignature(): boolean {
    return TypeSignature.CLOUD === this.document._more.typeSignature;
  }

  get isEnable4sendOTP(): boolean {
    return this.enableOTP;
  }

  get typeSignature(): number {
    return this.document._more.typeSignature;
  }

  get isCloudSignatureComplete(): boolean {
    if (this.isCloudSignature) {
      return this.needRubric;
    } else {
      return true;
    }
  }

  /**
   * Verifica si esta habilitado documentIntegrity para la firma gráfica con integridad del documento.
   */
  get haveDocumentIntegrityToGraficSign() {
    return this.document._more.documentIntegrity;
  }

  get isElectronicSignature(): boolean {
    return TypeSignature.ELECTRONIC === this.document._more.typeSignature;
  }

  get hasPowerValidity1() {
    return this.document._more.hasPowerValidity || this.hasPowerValidity;
  }

  get hasRUCFile1() {
    return this.document._more.hasRUCFile || this.hasRUCFile;
  }

  get acceptRubricPlacementChecked() {
    return this.document._more.acceptRubricPlacement;
  }

  get loadMessageHtml() {
    if (this.acceptRubricPlacementChecked) {
      const message = this.translate.instant('MESSAGE.DRAG-AND-DROP-RUBRIC-TO-DOCUMENTS');
      const note = this.translate.instant('TITLE.ATTENTION');
      return `<strong>¡${note}!</strong><div>${message}</div>`;
    }
  }

  private reloadPdf() {
    this.reloadingPdf = true;
    this.documentService.download(this.resource.url).subscribe(value => {
      const file = new Blob([value], {type: 'application/pdf'});
      this.urlStream = URL.createObjectURL(file);
      this.reloadingPdf = false;
    }, () => {
      this.reloadingPdf = false;
    });
  }

  public downloadDocument(documentsource: Document) {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/public/documents/').concat(String(documentsource.id)).concat('/stream1');
    const more = documentsource._more;
    this.documentService.download(url).subscribe(next => {
      const control = document.createElement('a');
      control.setAttribute('style', 'display:none;');
      document.body.appendChild(control);
      control.href = window.URL.createObjectURL(next);
      control.download = more.basenameFile.concat(more.suffix === undefined ? '' : more.suffix, '.', more.extension);
      control.click();
      this.loading = false;
    }, error => {
      this.loading = false;
      const title = this.translate.instant('TITLE.DOWNLOAD-DOCUMENTS');
      Dialog.show(InformType.Danger, title);
    });
  }

  private countDown() {
    this.secondLeft = 60;
    this.enableOTP = true;
    this.intervalCountDown = setInterval(() => {
      this.secondLeft = Math.floor(this.secondLeft - 1);
      // @ts-ignore
      if (this.secondLeft === 0) {
        this.enableOTP = false;
        clearInterval(this.intervalCountDown);
        const btnElement = document.getElementById('btnSendOTP');
        btnElement.removeAttribute('disabled');
      }
    }, 1000);
  }
}
